import { DELETE_NOTIFICATION, GET_ALL_NOTIFICATION, GET_LATEST_NOTIFICATION,UPDATE_NEW_NOTIFICATION } from "./keys";

const initialState = {
    notificationList: [],
    latestNotifionList: [],
    notificationListLength: 0
}
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_NOTIFICATION: {
            const { notifications, notificationsCount } = action.payload;
            return { ...state, notificationList: notifications, notificationListLength: notificationsCount }
        }

        case GET_LATEST_NOTIFICATION: {
            const { notifications, notificationsCount } = action.payload;
            return { ...state, latestNotifionList: notifications, notificationListLength: notificationsCount }
        }

        case DELETE_NOTIFICATION: {
            const id = action.payload;
            const updateNotificationList = state.notificationList.filter((notification) => notification.id !== id);
            return { ...state, notificationList: updateNotificationList, notificationListLength: state.notificationListLength - 1 }
        }
        case UPDATE_NEW_NOTIFICATION:{
            const { notifications, notificationsCount } = action.payload;
            const newNotifications = [...notifications,...state.latestNotifionList]
            return { ...state, latestNotifionList: newNotifications, notificationListLength: notificationsCount }
        }


        default:
            return { ...state }
    }
}
